// app/javascript/modules/admissoes/cargo_salario.js

export function initCargoSalario($j, $form, h, api) {
  const ns = ".admissaoCargoSalario"

  // cache: { "Porteiro": 1500.00, "Zelador": 1800.00, ... }
  let salariosPorCargo = {}
  // salario base do cargo selecionado (null se nao houver)
  let salarioBase = null
  // flag para bloquear envio do form
  let bloqueado = false

  const $salarioInput = $form.find("#params_salario")
  const $refBox = $form.find("#salario-base-ref")
  const $refValor = $form.find("#salario-base-valor")
  const $alertaBox = $form.find("#salario-alerta")

  // ---- helpers ----

  function parseMoney(str) {
    if (str == null) return NaN
    const s = String(str).trim()
    if (!s) return NaN
    // "1.234,56" -> 1234.56  |  "1234.56" -> 1234.56
    if (s.includes(",")) {
      return parseFloat(s.replace(/\./g, "").replace(",", "."))
    }
    return parseFloat(s)
  }

  function formatBRL(num) {
    if (isNaN(num)) return "—"
    return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
  }

  function setBloqueio(flag) {
    bloqueado = flag
    // marca no form para o crud/form_controller poder consultar
    $form.data("salario-bloqueado", flag)
  }

  // ---- exibe referencia e alerta ----

  function atualizaReferencia() {
    if (salarioBase != null && !isNaN(salarioBase)) {
      $refValor.text(formatBRL(salarioBase))
      $refBox.removeClass("hidden")
    } else {
      $refBox.addClass("hidden")
    }
  }

  function validaSalario() {
    const valor = parseMoney($salarioInput.val())

    // se nao tem salario base ou input vazio, limpa alerta
    if (salarioBase == null || isNaN(salarioBase) || isNaN(valor)) {
      $alertaBox.addClass("hidden").empty()
      setBloqueio(false)
      return
    }

    if (valor < salarioBase) {
      $alertaBox
        .removeClass("hidden border-yellow-300 bg-yellow-50 text-yellow-800")
        .addClass("border-red-300 bg-red-50 text-red-800")
        .html(
          '<i class="fas fa-exclamation-triangle mr-1"></i>' +
          '<strong>Salário abaixo da convenção salarial.</strong> Não é permitido prosseguir com este valor.'
        )
      setBloqueio(true)
    } else if (valor > salarioBase) {
      $alertaBox
        .removeClass("hidden border-red-300 bg-red-50 text-red-800")
        .addClass("border-yellow-300 bg-yellow-50 text-yellow-800")
        .html(
          '<i class="fas fa-exclamation-triangle mr-1"></i>' +
          '<strong>Risco de equiparação salarial.</strong> Entre em contato com o DP Admissão antes de prosseguir.<br>' +
          '<span class="mt-1 inline-block text-xs">' +
          'Contato: <strong>Patricia</strong> &mdash; ' +
          'Tel: <a href="tel:+551130039818" class="underline">(11) 3003-9818</a> &mdash; ' +
          'E-mail: <a href="mailto:admissao@protelcondominios.com.br" class="underline">admissao@protelcondominios.com.br</a>' +
          '</span>'
        )
      setBloqueio(true)
    } else {
      // igual ao base
      $alertaBox.addClass("hidden").empty()
      setBloqueio(false)
    }
  }

  // ---- quando cargo muda ----

  function onChangeCargo() {
    const cargoSelecionado = $form.find("#params_cargo").val()

    if (!cargoSelecionado || cargoSelecionado === "outros") {
      salarioBase = null
      atualizaReferencia()
      $salarioInput.val("")
      $alertaBox.addClass("hidden").empty()
      setBloqueio(false)
      return
    }

    // se ja temos cache, usa direto
    if (Object.keys(salariosPorCargo).length > 0) {
      aplicaCargo(cargoSelecionado)
      return
    }

    // busca da API
    if (!api.salariosUrl) return

    $j.ajax({
      url: api.salariosUrl,
      type: "GET",
      dataType: "json",
      data: { term: cargoSelecionado },
      success: (data) => {
        const results = (data && data.results) ? data.results : []
        salariosPorCargo = {}
        for (let i = 0; i < results.length; i++) {
          salariosPorCargo[results[i][0]] = parseFloat(results[i][1]) || 0
        }
        aplicaCargo(cargoSelecionado)
      },
      error: (_xhr, status, error) => console.error("Erro na requisição AJAX:", status, error),
    })
  }

  function aplicaCargo(cargo) {
    const base = salariosPorCargo[cargo]
    if (base != null && !isNaN(base) && base > 0) {
      salarioBase = base
      $salarioInput.val(formatBRL(base).replace("R$\u00a0", "").replace("R$ ", ""))
    } else {
      salarioBase = null
      $salarioInput.val("")
    }
    atualizaReferencia()
    validaSalario()
  }

  // ---- quando salario muda manualmente ----

  function onChangeSalario() {
    validaSalario()
  }

  // ---- intercepta submit se bloqueado ----

  function onBeforeSubmit(e) {
    if (bloqueado) {
      e.preventDefault()
      e.stopImmediatePropagation()

      // Scroll to alerta
      if ($alertaBox.length) {
        $alertaBox[0].scrollIntoView({ behavior: "smooth", block: "center" })
      }
      return false
    }
  }

  // ---- bind events ----

  $form.off(ns)
  $form.on(`change${ns}`, "#params_cargo", onChangeCargo)
  $form.on(`input${ns} change${ns} blur${ns}`, "#params_salario", onChangeSalario)
  $form.on(`submit${ns}`, onBeforeSubmit)

  return {
    destroy() {
      $form.off(ns)
    }
  }
}
